import { formatDate } from 'helpers/datesHelper.js';
const encode = encodeURIComponent;
const today = new Date();

export default (requests, axios) => {
  return {
    getTransactionsByFilter: ({
      activeTab = 'all',
      endDate = today,
      startDate = today,
      limit = 10,
      currentPage = 0,
      activeFilter = 'all',
    } = {}) => {
      const offset = currentPage * limit;
      const dateFrom = formatDate(startDate, 'yyyy-MM-dd');
      const dateTo = formatDate(endDate, 'yyyy-MM-dd');
      return requests.get(
        `/transaction/transactions/${dateFrom}/${dateTo}/${limit + 1}/${offset}/${activeTab}${
          activeFilter != 'all' ? `?eventsSlipType=${activeFilter}` : ''
        }`
      );
    },
    getCashouts: ({ endDate = today, startDate = today } = {}) => {
      const dateFrom = formatDate(startDate, 'yyyy-MM-dd');
      const dateTo = formatDate(endDate, 'yyyy-MM-dd');
      return requests.get(`/cashout/bets/${dateFrom}/${dateTo}/`);
    },
    getMultiCashouts: (betSlipsIds = []) => {
      return requests.get(`/cashout/multi/maxAmount/${betSlipsIds.join(',')}`);
    },
    cashoutMaximumAmount: (slipId) => {
      return requests.get(`/cashout/max/${slipId}`);
    },
    cashoutPartialAmount: (slipId, data) => {
      return requests.post(`/cashout/partial/${slipId}/`, data);
    },
    cashoutFullAmount: (slipId, data) => {
      return requests.post(`/cashout/full/${slipId}/`, data);
    },
    cashoutPrepareLiveCountDown: (slipId, data) => {
      return requests.post(`/cashout/prepare-live-countdown/${slipId}`, data);
    },
    getCashoutNowAmount: (slipId) => {
      return requests.get(`/cashout/now/${slipId}`);
    },
    cashoutFullMarkForWithdraw: (slipId, cashoutCode, data) => {
      return requests.post(`/cashout/now/${slipId}/${cashoutCode}/${data.requestedAmount}`, data);
    },
    cashoutPartialMarkForWithdraw: (slipId, cashoutCode, data) => {
      return requests.post(`/cashout/partial/now/${slipId}/${cashoutCode}`, data);
    },
  };
};
